import { ApiResponse } from '@packages/database/types';
import api from './client/axios';

export const claimTicket = async (ticketId: string): Promise<any> => {
  const response = await api.post<ApiResponse<any>>(
    `/tickets/${ticketId}/claim`,
  );
  return response.data.data;
};

export const joinTicket = async (ticketId: string): Promise<any> => {
  const response = await api.post<ApiResponse<any>>(
    `/tickets/${ticketId}/join`,
  );
  return response.data.data;
};

export const transferEditRights = async (
  ticketId: string,
  toUserId: string,
): Promise<void> => {
  await api.post(`/tickets/${ticketId}/transfer-edit`, { toUserId });
};
